<div class="ac-page c7-access-view c7-access-legal-document">

  <header class="ac-topbar">
    <div class="ac-topbar__inner">
      <app-back-button></app-back-button>
      <a class="ac-brand" routerLink="/login" aria-label="CULTURA">
        <img src="assets/logo-blue.png" alt="CULTURA" class="ac-brand__logo" />
      </a>
      <label class="ac-lang">
        <span>{{ "acceptPage.language" | translate }}</span>
        <select [value]="selectedLanguage" (change)="changeLanguage($any($event.target).value)">
          <option *ngFor="let language of supportedLanguages" [value]="language.code">{{ language.name }}</option>
        </select>
      </label>
    </div>
  </header>

  <main class="ac-main ac-main--center ac-main--top">
    <p class="ac-status" *ngIf="state === 'loading'" role="status">{{ "uiPack.common.loading" | translate }}</p>

    <article class="ac-card ac-card--doc" *ngIf="state !== 'loading'" aria-labelledby="ac-legal-title">
      <h1 id="ac-legal-title">{{ titleKey | translate }}</h1>

      <ng-container *ngIf="state === 'ready'">
        <p class="ac-doc__meta">
          {{ "legalPages.stand" | translate: { date: published, version: version } }}
        </p>
        <p class="ac-doc__notice" *ngIf="isTranslation || usesFallback" role="note">
          {{ (usesFallback ? "legalPages.fallbackNotice" : "legalPages.translationNotice") | translate }}
        </p>
        <div class="ac-doc__body" [innerHTML]="html"></div>
      </ng-container>

      <p *ngIf="state === 'missing'">{{ "legalPages.missing" | translate }}</p>

      <div class="ac-doc__back"><app-back-button></app-back-button></div>
    </article>
  </main>

  <app-auth-footer></app-auth-footer>
</div>
